// © 2024–2026 Jos Jozef Sytze van der Werf — Alle rechten voorbehouden.
import { useNavigate } from 'react-router-dom'
import { Leaf, ArrowLeft } from 'lucide-react'
import { Button } from '@/components/ui'
import { ROUTES } from '@/lib/constants/routes'

export function NotFoundPage() {
  const navigate = useNavigate()
  return (
    <div className="min-h-screen bg-sand flex flex-col items-center justify-center px-6 text-center">
      <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-moss mb-6">
        <Leaf className="h-7 w-7 text-white" />
      </div>
      <h1 className="text-2xl font-bold text-ink mb-2">Pagina niet gevonden</h1>
      <p className="text-sm text-ink-3 mb-8 max-w-xs">
        De pagina die u zoekt bestaat niet of is verplaatst.
      </p>
      <Button
        onClick={() => navigate(ROUTES.DASHBOARD)}
        icon={<ArrowLeft className="h-4 w-4" />}
      >
        Terug naar dashboard
      </Button>
    </div>
  )
}
